import * as React from "react";
import { DatasetVersionTableContext } from "./context";

export const DatasetVersionTableContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [page, setPage] = React.useState(0);
  return (
    <DatasetVersionTableContext.Provider value={{ page, setPage }}>
      {children}
    </DatasetVersionTableContext.Provider>
  );
};
